import PropTypes from 'prop-types'
import classNames from 'classnames'
import Icon from 'components/Icon'

const SortArrow = ({ order }) => (
  <Icon
    name="sort"
    className={classNames('ico_comm', {
      sort_up: order === 'asc',
      sort_down: order === 'desc',
    })}>
    정렬
  </Icon>
)
SortArrow.propTypes = {
  order: PropTypes.oneOf(['asc', 'desc']),
}
export default SortArrow
